import { createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { Body } from 'copilot-design-system';

const useStyles = makeStyles(() =>
  createStyles({
    one: {
      opacity: 0,
      WebkitAnimation: '$dot 1.3s infinite',
      WebkitAnimationDelay: '0.0s',
      animation: '$dot 1.3s infinite',
      animationDelay: '0.0s',
    },
    two: {
      opacity: 0,
      WebkitAnimation: '$dot 1.3s infinite',
      WebkitAnimationDelay: '0.2s',
      animation: '$dot 1.3s infinite',
      animationDelay: '0.2s',
    },
    three: {
      opacity: 0,
      WebkitAnimation: '$dot 1.3s infinite',
      WebkitAnimationDelay: '0.3s',
      animation: '$dot 1.3s infinite',
      animationDelay: '0.3s',
    },
    '@keyframes dot': {
      '0%': { opacity: 0 },
      '50%': { opacity: 0 },
      '100%': { opacity: 1 },
    },
  }),
);

const textClasses = 'font-medium leading-6';
const containerClasses = 'flex items-center';

interface ChannelTypingIndicatorProps {
  typingUsers: Array<{
    user?: {
      id?: string;
      name?: string;
    };
  }>;
}

export const ChannelTypingIndicator = ({
  typingUsers,
}: ChannelTypingIndicatorProps) => {
  const classes = useStyles();

  if (!typingUsers || typingUsers.length === 0) {
    return null;
  }

  const renderAnimatingDots = () => (
    <>
      <Body
        className={clsx('text-gray-small', textClasses, classes.one)}
        size="sm"
        tag="div"
      >
        .
      </Body>
      <Body
        className={clsx('text-gray-small', textClasses, classes.two)}
        size="sm"
        tag="div"
      >
        .
      </Body>
      <Body
        className={clsx('text-gray-small', textClasses, classes.three)}
        size="sm"
        tag="div"
      >
        .
      </Body>
    </>
  );

  return (
    <>
      {typingUsers.length === 1 && (
        <div className={containerClasses}>
          <Body className={textClasses} size="sm" tag="div">
            {`${typingUsers.at(0)?.user?.name}`}
          </Body>
          &nbsp;
          <Body className="leading-5 text-gray-small" size="sm" tag="div">
            is typing
          </Body>
          {renderAnimatingDots()}
        </div>
      )}

      {typingUsers.length > 1 && (
        <div className={containerClasses}>
          <Body className={textClasses} size="sm" tag="div">
            Multiple people
          </Body>
          &nbsp;
          <Body className="leading-5 text-gray-small" size="sm" tag="div">
            are typing
          </Body>
          {renderAnimatingDots()}
        </div>
      )}
    </>
  );
};
